module.exports = __webpack_public_path__ + "img/self-check-in-icon.abe80f9a.svg";